<h1 mat-dialog-title
    [ngClass]="this.title.includes('Alert')?'text-red-700':'text-green-600'">{{title}}</h1>
<div mat-dialog-content>
    <p class="mat-body-1">{{message}}</p>
</div>
<div mat-dialog-actions align="center">
    <button mat-raised-button color="warn" (click)="onNo('no')">Cancel</button>
    <button mat-raised-button color="primary" (click)="onYes('yes')">Yes</button>
</div>